import { render } from "./AppFastCloud.vue?vue&type=template&id=05e545d4&ts=true&lang=pug"
import script from "./AppFastCloud.vue?vue&type=script&lang=ts"
export * from "./AppFastCloud.vue?vue&type=script&lang=ts"

import "./AppFastCloud.vue?vue&type=style&index=0&id=05e545d4&lang=scss"

import exportComponent from "C:\\Users\\ZiegFreeze\\Documents\\Work\\upa-fast-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__